/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { memo } from 'react';

import { useHomeHref } from '../../api/use';
import Link from '../navigation/Link';
import Logo from './Logo';
import Container from './Container';

const Header = memo(({ children, isFixed = true, isSticky = false }) => {
	const homeHref = useHomeHref();

	return (
		<div
			css={(theme) => css`
				z-index: ${theme.zIndex.header};
				position: ${isSticky ? 'sticky' : isFixed ? 'fixed' : 'static'};
				left: 0;
				top: 0;
				right: 0;
				pointer-events: none;
			`}
		>
			<Container
				limit={false}
				margin={false}
				css={css`
					display: flex;
					justify-content: space-between;
					align-items: flex-start;
					padding-top: 1em;
					padding-bottom: 1em;
				`}
			>
				<Container limit={false} margin={false} padding={false}>
					<Link
						href={homeHref}
						title="Homepage"
						css={(theme) => [
							css`
								display: block;
								color: ${theme.color.primaryContrast} !important;
								text-decoration: none;
								pointer-events: all;
							`,
						]}
					>
						<Logo />
					</Link>
				</Container>
				{children}
			</Container>
		</div>
	);
});

export default Header;
